function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
  requiredExtensions: "&ns_ai;",
  x: 0,
  y: 0,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("iPgfRef", {
  xlinkHref: "#adobe_illustrator_pgf"
})), /*#__PURE__*/React.createElement("g", {
  iExtraneous: "self"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  points: "0.5,24.2  13,2.3 25.5,24.2  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M12.3,8.4c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.4,0L13.5,18 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0L12.3,8.4z M12.1,21.8c0-0.3-0.1-0.5-0.1-0.8 c0-0.3,0-0.5,0.1-0.8c0.3,0,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.8,0.1c0,0.3,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8 c-0.3,0-0.5,0.1-0.8,0.1C12.7,21.9,12.4,21.8,12.1,21.8"
}))));

var SvgViolation = function SvgViolation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViolation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/violation.a709ddfb.svg";
export { ForwardRef as ReactComponent };